'use strict';

import escape from 'escape-html'
import adjustInfoVertical from '../../utils/adjustInfoVertical'


export class HideControl {
  constructor(element, svg) {
    this.$control = document.createElement('div')
    this.$control.classList.add('si_controls__control')
    this.$control.classList.add('si_control')
    this.$control.classList.add('si_control--toggle')

    const $label = document.createElement('label')
    $label.classList.add(`si_control__label`)
    $label.innerHTML = 'Visible'

    this.$input = document.createElement('input')
    this.$input.classList.add(`si_control__input`)
    this.$input.classList.add(`si_input`)
    this.$input.classList.add(`si_input--toggle`)
    this.$input.setAttribute('type', 'checkbox')

    this.origValue = element.attr('visibility') != 'hidden'
    this.setValue(this.origValue)
    //

    this.$input.addEventListener('change', (e) => {
      if (e.target.checked) {
        element.node.removeAttribute('visibility');
        var bisElement = element.attr('si:bis') ? true : false

        if (bisElement) {
          var bisName = escape(element.attr('si:bis'));
          var bisElem = svg.select(bisName + ' text');
          //
          bisElem.node.removeAttribute('visibility');
          adjustInfoVertical(bisElem, true);
        }
      } else {
        element.node.setAttribute('visibility', 'hidden')
        var bisElement = element.attr('si:bis') ? true : false

        if (bisElement) {
          var bisName = escape(element.attr('si:bis'));
          var bisElem = svg.select(bisName + ' text');
          //
          bisElem.node.setAttribute('visibility', 'hidden')
          adjustInfoVertical(bisElem, true);
        }
      }
      adjustInfoVertical(element);



    })

    this.$control.appendChild($label)
    $label.appendChild(this.$input)

    this.reset = this.reset.bind(this, element)

    return this
  }

  getElement() {
    return this.$control
  }

  setValue(value) {
    this.$input.checked = value
    return this
  }

  getValue() {
    return this.$input.value
  }

  reset(element) {
    !this.origValue ? element.node.setAttribute('visibility', 'hidden') : element.node.removeAttribute('visibility')
    this.setValue(this.origValue)

    return this
  }
}
